module.exports = __webpack_public_path__ + "img/cake-5.f4e165dc.svg";